import flex from "@/utils/flex";
import styled, { css } from "styled-components";
import { desktop, mobile, tablet } from "@/utils/responsive";

export const Body = styled.div`
  ${flex({ direction: "column" })}
  height: 90vh;
  font-size: 2.5rem;
  div {
    margin-bottom: 1rem;
  }
  button {
    border: none;
    margin: 2rem;
    width: 200px;
    height: 100px;
    cursor: pointer;
    border-radius: 30px;
    :hover,
    :active {
      background-color: var(--sub);
    }
  }
  .flexDiv {
    ${flex({ gap: "20px" })}
  }
  .flexCol {
    ${flex({ direction: "column" })}
  }

  // responsive
  ${mobile(css`
    font-size: 1.2rem;
    .flexDiv {
      ${flex({ direction: "column", gap: "0" })}
    }
    .title {
      font-size: 1.5rem;
    }
    button {
      width: 200px;
      height: 70px;
      margin: 1rem;
    }
  `)}
  ${tablet(css`
    font-size: 1.5rem;
    .title {
      font-size: 2rem;
    }
  `)}
  ${desktop(css``)}
`;

export const StImage = styled.div<{ pic: string }>`
  background-image: url(${(props) => props.pic});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 48vw;
  height: 70vh;
  border: 5px solid var(--black);
  cursor: pointer;
  &:hover {
    opacity: 50%;
  }
  // responsive
  ${mobile(css`
    width: 80vw;
    height: 30vh;
  `)}
  ${tablet(css`
    width: 45vw;
    height: 70vh;
  `)}
  ${desktop(css``)}
`;

export const StLastImage = styled(StImage)<{ pic: string }>`
  &:hover {
    opacity: 100%;
  }
  cursor: default;
`;
